import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      lastUpdated="December 2025"
      testId="terms-page"
    >
      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">1. Introduction</h2>
      <p>
        These Terms govern your use of the Smashed Burger &amp; Bao Boy website. By accessing or
        using the site, you agree to be bound by these Terms.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">2. Ordering</h2>
      <p>
        Orders for delivery are placed and fulfilled through third-party platforms such as Uber
        Eats and are subject to those platforms' terms. Prices and availability on our site are
        indicative; the order platform's prices apply at checkout.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">3. Allergens &amp; dietary information</h2>
      <p>
        Our kitchen handles wheat, soy, dairy, eggs, sesame, sulphites, mustard, and other
        allergens. While we take steps to minimise cross-contact, we cannot guarantee any item is
        free of trace allergens. Please call us on 01273 775335 before ordering if you have a
        severe allergy.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">4. Intellectual property</h2>
      <p>
        All content on this site — branding, photography, menu copy — is the property of
        Smashed Burger &amp; Bao Boy and may not be reproduced without written permission.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">5. Liability</h2>
      <p>
        To the fullest extent permitted by law, we exclude liability for any indirect or
        consequential loss arising from use of this site. Nothing in these Terms limits liability
        that cannot be limited under English law.
      </p>

      <h2 className="font-heading text-3xl uppercase tracking-tight text-white">6. Governing law</h2>
      <p>
        These Terms are governed by the laws of England and Wales, and any disputes shall be
        subject to the exclusive jurisdiction of the English courts.
      </p>
    </LegalPage>
  );
}
